import UserMutationProvider from '../contexts/userMutationContext';
import { EditUserForm } from '../components/EditUserForm';

export const EditUserPage = () => {
  return (
    <UserMutationProvider>
      <EditUserForm />
    </UserMutationProvider>
  );
};
